module.exports = __webpack_public_path__ + "static/media/lighttext@4x.c5f400d5.png";